import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@mui/icons-material';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { COSCellProps, COSTable, COSTextField } from '../../helpers/ui';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import Axios from 'axios';
import { CompanyResponse } from '../../services/api';
import { parseQuery } from '../../helpers/url';
import useCompanies from '../../helpers/hooks/useCompanies';
import { useNavigate } from 'react-router-dom';
import withErrorHandler from '../../helpers/hoc/withErrorHandler/withErrorHandler';

const apiFetchSize = 25;

const CompaniesComponent = () => {
  const { selectedPage } = parseQuery(location.search);
  const [search, setSearch] = useState<string>('');
  const { companies, loading, setParameters } = useCompanies(undefined, apiFetchSize, 0);
  const [page, setPage] = useState<number>(selectedPage ? +selectedPage : 0);
  const tableContainerRef = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();

  useEffect(() => {
    setParameters([search, apiFetchSize, page * apiFetchSize]);
  }, []);

  const onEnter = useCallback(() => {
    setPage(0);
    setParameters([search, apiFetchSize, 0]);
    navigate('/companies');
  }, [search]);

  useEffect(() => {
    setParameters([search, apiFetchSize, page * apiFetchSize]);
    navigate(`/companies?selectedPage=${page}`);
  }, [page]);

  useEffect(() => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollTop = 0;
    }
  }, [companies]);

  return (
    <Box sx={{ margin: 2 }}>
      <Typography align="center" variant="h5" component="h6">
        Companies
      </Typography>
      <Box sx={{ margin: 2 }}>
        <Grid container spacing={1}>
          <Grid item lg={9}>
            <COSTextField
              label="Search"
              value={search}
              onChange={(value: string) => setSearch(value)}
              onEnter={onEnter}
            />
          </Grid>
          <Grid item lg={12}>
            <COSTable<CompanyResponse>
              isLoading={loading}
              data={companies}
              muiTableContainerProps={{
                ref: tableContainerRef,
                sx: { maxHeight: '60vh', minHeight: '300px' }
              }}
              columns={[
                {
                  accessorKey: 'id',
                  header: '#',
                  size: 50,
                  Cell: ({ row }: COSCellProps<CompanyResponse>) =>
                    row.index + page * apiFetchSize + 1
                },
                {
                  accessorKey: 'name',
                  header: 'Name',
                  enableColumnOrdering: false,
                  enableEditing: false, // disable editing on this column
                  enableSorting: false,
                  size: 100
                }
              ]}
              renderBottomToolbarCustomActions={() => (
                <Box sx={{ display: 'flex', margin: 'auto', justifyContent: 'space-around' }}>
                  <IconButton
                    onClick={() => setPage(page > 0 ? page - 1 : 0)}
                    disabled={page === 0}
                  >
                    <ArrowBackIosOutlined />
                  </IconButton>
                  <Box sx={{ marginLeft: 2, marginRight: 2, paddingTop: 0.5, color: '#717171' }}>
                    <Typography align="center" variant="h4" component="h5">
                      {page + 1}
                    </Typography>
                  </Box>
                  <IconButton
                    onClick={() => setPage(page + 1)}
                    disabled={companies.length < apiFetchSize}
                  >
                    <ArrowForwardIosOutlined />
                  </IconButton>
                </Box>
              )}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default withErrorHandler(CompaniesComponent, Axios);
